export default __webpack_public_path__ + "static/media/TransportationSpaceships_01.511218ea.png";